import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import { errMsg } from '../../utils/format';

const cardStyle = {
  minHeight: '100vh', display: 'flex', alignItems: 'center',
  justifyContent: 'center', background: 'var(--page-bg)', padding: 20,
};
const boxStyle = {
  background: 'var(--card-bg)', border: '0.5px solid var(--card-border)',
  borderRadius: 'var(--radius-lg)', padding: '32px 28px', width: '100%', maxWidth: 400,
  boxShadow: 'var(--shadow-md)',
};

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/api/auth/forgot-password', { email });
      setSent(true);
    } catch {
      setSent(true); // Never reveal errors
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={cardStyle}>
      <div style={boxStyle}>
        <h2 style={{ fontSize: 17, fontWeight: 500, marginBottom: 8 }}>Reset your password</h2>
        {sent ? (
          <>
            <div className="alert alert-info" style={{ marginBottom: 16 }}>
              <i className="ti ti-mail" />
              If that email is registered, a reset link has been sent. Check your inbox.
            </div>
            <Link to="/login" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
              Back to sign in
            </Link>
          </>
        ) : (
          <>
            <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 20 }}>
              Enter your email address and we'll send you a link to reset your password.
            </p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email address</label>
                <input type="email" required autoFocus value={email}
                  onChange={e => setEmail(e.target.value)} />
              </div>
              <button className="btn btn-primary" type="submit" disabled={loading}
                style={{ width: '100%', justifyContent: 'center' }}>
                {loading ? 'Sending…' : 'Send reset link'}
              </button>
            </form>
            <div style={{ textAlign: 'center', marginTop: 14 }}>
              <Link to="/login" style={{ fontSize: 13, color: 'var(--blue)' }}>Back to sign in</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export function ResetPassword() {
  const token = new URLSearchParams(window.location.search).get('token');
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) { setError('Passwords do not match'); return; }
    setError(''); setLoading(true);
    try {
      await api.post('/api/auth/reset-password', { token, password: form.password });
      setDone(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  if (!token) return (
    <div style={cardStyle}><div style={boxStyle}>
      <div className="alert alert-danger"><i className="ti ti-alert-circle" />Invalid reset link.</div>
      <Link to="/login" className="btn" style={{ marginTop: 12 }}>Back to sign in</Link>
    </div></div>
  );

  return (
    <div style={cardStyle}>
      <div style={boxStyle}>
        <h2 style={{ fontSize: 17, fontWeight: 500, marginBottom: 16 }}>Set new password</h2>
        {done ? (
          <>
            <div className="alert alert-success" style={{ marginBottom: 16 }}>
              <i className="ti ti-check" />Password reset successfully.
            </div>
            <Link to="/login" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
              Sign in
            </Link>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <div className="alert alert-danger" style={{ marginBottom: 12 }}>
              <i className="ti ti-alert-circle" />{error}
            </div>}
            <div className="form-group">
              <label>New password</label>
              <input type="password" required minLength={8} value={form.password}
                onChange={e => setForm(f => ({ ...f, password: e.target.value }))} />
              <small style={{ color: 'var(--text-tertiary)', fontSize: 11 }}>
                Min 8 characters, 1 uppercase, 1 number
              </small>
            </div>
            <div className="form-group">
              <label>Confirm password</label>
              <input type="password" required value={form.confirm}
                onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))} />
            </div>
            <button className="btn btn-primary" type="submit" disabled={loading}
              style={{ width: '100%', justifyContent: 'center' }}>
              {loading ? 'Resetting…' : 'Reset password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
